<template>
    <div class="toggle-buttons">
        <p class="control has-addons">
            <toggle-button :active="value == button.value" v-model="val" v-for="(button, index) in buttons" :key="index">{{ button.label }}</toggle-button>
        </p>
    </div>
</template>


<script>
    import { ToggleButton } from '../';

    export default {
        name: 'toggle-buttons',

        props: ['buttons', 'value'],

        components: {
            ToggleButton,
        },

        data() {
            return {
                val: this.value,
            };
        },

        watch: {
            val(newValue, oldValue) {
                this.$emit('input', newValue);
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/views/components/toggle-buttons/toggleButtons.vue